import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { BREAKPOINTS } from '../../settings';

const Cta = ({ text, link, image }) => {
  if(text && link) {
    return (
      <Wrapper>
        <Link href={link}>
          <Title>{text}</Title>
        </Link>
        {image ? <Image src={image} alt="" /> : null}
      </Wrapper>
    )
  }

  return null;
}

Cta.propTypes = {
  text: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string,
};

const Wrapper = styled.div`
  margin-top: 40px;
`;

const Link = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {

  }
`;

const Title = styled.h3`
  font-size: 1rem;
  letter-spacing: 3px;
  margin: 0 0 24px 0;
  @media (min-width: ${BREAKPOINTS.sm}) {
    font-size: 1.2rem;
  }
`;

const Image = styled.img`
  display: block;
  margin: 0 auto -20px auto; // Pull flush with container bottom edge
`;

export default Cta;
